export default class ScrollToTop {

    // Constructor
    constructor() {
        this.button = null;
        this.scrollReference = 300;
        this.ticking = false;
    }

    // Init before frameworks
    init() {
		this.button = document.getElementById('scroll-to-body');

        if (this.button) {
			this.setEvent_buttonClick();
			this.setEvent_hideOnScroll();
		}
    }

    // Init after frameworks
    initAfterFrameworks() { }

    // Destroy
    destroy() {
		window.removeEventListener('scroll', this._hideOnScroll, true);

        if (this.button) {
			this.button.removeEventListener('click', this._buttonClick, true);
		}
    }

    // Set event: scroll to body click
    setEvent_buttonClick() {
		const masthead = document.querySelector('.tps-comp-masthead');

		if (masthead) {
			this.scrollReference = masthead.offsetHeight + 20; // 20px diff between header scrolled and not scrolled
		}

        this.button.addEventListener('click', this._buttonClick, true);
	}

	// Scroll to body click
	_buttonClick(e) {
		const self = window.tps.scrollToTop; // this;
		const scrollBehavior = window.matchMedia('(prefers-reduced-motion)').matches ? 'auto' : 'smooth';

		if (window.tps.polyfill.supportsNativeSmoothScroll) {
			window.scroll({
				top: self.scrollReference,
				behavior: scrollBehavior
			});
		} else {
			window.tps.polyfill.smoothScrollTo(self.scrollReference, 500);
		}

		self.button.blur();
	}

    // Set event: hide button on scroll
    setEvent_hideOnScroll() {
        window.addEventListener('scroll', this._hideOnScroll, true);
        this._hideButton(window.scrollY);
	}

	// Hide button on scroll
	_hideOnScroll(e) {
		const self = window.tps.scrollToTop; // this;

		if (!self.ticking) {
			window.requestAnimationFrame(function() {
				self._hideButton(window.scrollY);
				self.ticking = false;
			});

			self.ticking = true;
		}
	}

    // Helper: hide button on scroll
    _hideButton(scrollPosition) {
        const isHidden = scrollPosition >= this.scrollReference;

        if (isHidden) {
            this.button.classList.add('hidden');
        } else {
            this.button.classList.remove('hidden');
        }
	}

}
